<template>
  <div class="container">
    <button class="btn btn-danger float-end" @click.prevent="showCreatePrice()">Crear nuevo precio</button>
    <div class="container table-responsive mx-auto">
      <table class="table">
        <tbody>
          <tr>
            <th>Linea</th>
            <th>Nombre</th>
            <th>Valor</th>
            <th colspan="2"></th>
          </tr>
          <tr v-for="price in prices" :key="price.id">
            <td>{{ price.priceType }}</td>
            <td>{{ price.name }}</td>
            <td>{{ price.value }}</td>
            <td>
              <div>
                <button class="btn btn-danger" @click.prevent="editPrice(price.id)">
                  Editar
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <PriceRegister v-show="showPopUp" @hidePopUp="hideCreatePrice"></PriceRegister>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
import PriceRegister from "@/components/Admin/Prices/RegisterPriceAdminComponent.vue";
export default {
  data() {
    return {
      prices: [],
      showPopUp: false,
    };
  },
  components: {
    PriceRegister,
  },
  beforeMount() {
    this.loadPrices();
  },
  methods: {
    editPrice(priceId) {
      //console.log(priceId);
      this.$emit("sendPriceId", priceId);
    },
    showCreatePrice() {
      this.showPopUp = true;
    },
    hideCreatePrice(data) {
      this.showPopUp = data;
    },
    loadPrices() {
      axios
        .get(RUTA_SERVIDOR + "api/price/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((res) => (this.prices = res.data))
        .catch((err) => console.log(`There has been an error ${err}`));
    }
  },
};
</script>
<style scoped></style>